export default __webpack_public_path__ + "images/4Y.a332250.png";